type LumeeToken = `--btly-${string}`

// Payment iframes and the PiP window have their own documents, so they receive concrete values instead of var() references.
export const readCssToken = (name: LumeeToken): string => getComputedStyle(document.documentElement).getPropertyValue(name).trim()
